import * as React from "react"
const TicIconTrans = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...props}>
    <path d="M18.212 13.182h45.634C57.243 5.135 47.222 0 36 0 16.117 0 0 16.117 0 36c0 17.629 12.674 32.299 29.408 35.395V39.549H53.24v28.06C64.417 61.5 72 49.635 72 36H8.796z" />
  </svg>
)
export default TicIconTrans
